import { EntregaHackathon } from './../../../models/hackathon.model';
import { Equipe, EntregaEquipe, EntregaToShow } from './../../../models/equipe.model';
import { DatabaseService } from './../../../services/database.service';
import { HelpersService } from 'src/app/services/helpers.service';
import { Component, OnInit } from '@angular/core';
import { formatDate, getLocaleDateFormat, getLocaleId } from '@angular/common';

@Component({
  selector: 'app-entregaslist',
  templateUrl: './entregaslist.component.html',
  styleUrls: ['./entregaslist.component.css']
})
export class EntregaslistComponent implements OnInit {

  showSpinner = true;
  private equipe: Equipe;
  private entregasAFazer: EntregaHackathon[] = [];
  entregas: EntregaToShow[] = [];

  constructor(public helper: HelpersService,
              private database: DatabaseService) { }

  ngOnInit(): void {
    this.entregasAFazer = this.helper.hackathonEntregas;

    this.database.getEquipe(this.helper.getEquipeId())
    .then( rawData => rawData.subscribe((equipes: Equipe[]) => {
      this.equipe = equipes.find(e => e.equipeId === this.helper.getEquipeId());
      this.verificarSeEquipeTemAListaDeEntregas();
      this.showSpinner = false;
    }));
  }

  private verificarSeEquipeTemAListaDeEntregas() {
    this.entregasAFazer.forEach((entregaAFazer: EntregaHackathon) => {
      const indexEntrega = this.equipe.entregas.findIndex(e => e.titulo === entregaAFazer.titulo);

      if (indexEntrega === -1) {
        // Adiciona as entregas que faltam
        this.equipe.entregas.push({
          avaliativa: entregaAFazer.avaliativa,
          atrasado: false,
          entregue: false,
          dataHoraEntrega: '',
          conteudo: '',
          titulo: entregaAFazer.titulo,
        });

        this.entregas.push({
          atrasado: false,
          entregue: false,
          conteudo: '',
          titulo: entregaAFazer.titulo,
          descricao: entregaAFazer.descricao,
          dataHoraEntrega: '',
          dataHoraLimiteEntrega: entregaAFazer.dataHoraLimite,
        });
      } else {
        // captura as entregas que ja existem
        this.entregas.push({
          atrasado: this.equipe.entregas[indexEntrega].atrasado,
          entregue: this.equipe.entregas[indexEntrega].entregue,
          conteudo: this.equipe.entregas[indexEntrega].conteudo,
          titulo: entregaAFazer.titulo,
          descricao: entregaAFazer.descricao,
          dataHoraEntrega: this.equipe.entregas[indexEntrega].dataHoraEntrega,
          dataHoraLimiteEntrega: entregaAFazer.dataHoraLimite,
        });
      }
    });
  }

  entregar(entrega: EntregaToShow) {
    const indexEntrega = this.equipe.entregas.findIndex(e => e.titulo === entrega.titulo);

    this.equipe.entregas[indexEntrega].entregue = true;
    this.equipe.entregas[indexEntrega].conteudo = entrega.conteudo;
    this.equipe.entregas[indexEntrega].atrasado = this.helper.comparaDataHora(new Date(entrega.dataHoraLimiteEntrega), new Date());
    this.equipe.entregas[indexEntrega].dataHoraEntrega = new Date().toUTCString();

    // Salva a entrega
    this.database.updateEquipe(this.equipe)
    .then(() => {
      this.helper.openSnackBar(`Entrega: ${entrega.titulo}, realizada com sucesso!!`, '');
    });
  }

  dentroDoPrazo(entrega: EntregaToShow) {
    return this.helper.comparaDataHora(new Date(entrega.dataHoraLimiteEntrega), new Date());
  }
}
